import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SummaryFlowViewComponent } from '../../summary-flow-view/summary-flow-view.component';
import { DefaultDisplayComponent } from "../default-display/default-display.component";

@Component({
    selector: 'date-picker-display',
    templateUrl: './date-picker-display.component.html',
    styleUrls: ['./date-picker-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DatePickerDisplayComponent extends DefaultDisplayComponent implements OnInit {

    get displayValue(): string {
        if (this.value) {
            return this.summary.dateService.convertUtcStringToMMDDYYYY(this.value);
        }
        return "N/A";
    }

    constructor() {
        super();
    }

    ngOnInit() {
        super.ngOnInit();
    }

}
